<auto-main-navigation [accountId]="accountId"></auto-main-navigation>
<p-panel>
  <p-header class="settings-header-wrapper">
    <h1 class="settings-header">MPOP Settings</h1>
  </p-header>
  <div class="main-content-wrapper p-grid">
    <div class="p-col-3">
      <p-panelMenu [model]="settingsSideNav"></p-panelMenu>
    </div>
    <p-panel class="p-col ad-types-wrapper">
      <ng-template pTemplate="header">
        <div class="panel-header-content">
          <h2>IPOP</h2>
          @if (activeTab !== 'offerSetRules') {
            <button pButton class="p-button-success save-button" label="Save Settings"
                    [disabled]="getSaveButtonDisabled() || isSaving"
                    [loading]="isSaving"
                    (click)="saveSettings()"></button>
          }
        </div>
      </ng-template>
      <p-tabs [(value)]="activeTab">
        <p-tablist>
          <p-tab value="privateOffers">Private Offers <i class="pi pi-lock"></i></p-tab>
          <p-tab value="vdpOffers">VDP Offers <i class="pi pi-car"></i></p-tab>
          @if (ipopConfiguration?.canConfigureSiteWideUnlock) {
            <p-tab value="siteWideUnlock">Sitewide Unlock <i class="pi pi-globe" aria-hidden="true"></i></p-tab>
          }
          <p-tab value="offerSetRules">Offer Set Rules <i class="pi pi-file"></i></p-tab>
        </p-tablist>
      <p-tabpanels>
        <p-tabpanel value="privateOffers">
          <auto-private-offers
            [data]="ipopConfiguration"
            (formGroupInitialized)="onPrivateOffersFormGroupInitialized($event)">
          </auto-private-offers>
        </p-tabpanel>
        <p-tabpanel value="vdpOffers">
        <auto-vdp-offers
          [data]="ipopConfiguration"
          (formGroupInitialized)="onVdpOffersFormGroupInitialized($event)">
        </auto-vdp-offers>
          </p-tabpanel>
        @if (ipopConfiguration?.canConfigureSiteWideUnlock) {
          <p-tabpanel value="siteWideUnlock">
            <auto-site-wide-unlock [data]="ipopConfiguration" [accountId]="accountId" [isSaving]="isSaving"
              (formGroupInitialized)="onSiteWideUnlockFormGroupInitialized($event)">
            </auto-site-wide-unlock>
          </p-tabpanel>
        }
        <p-tabpanel value="offerSetRules">
          <auto-ipop-explicit-save-offer-set-rules
            [accountId]="accountId"
            [isOfferRegistryProcessingActive]="isOfferRegistryProcessingActive"
            [isProcessingRules]="isProcessingRules"
            [isSavingRules]="isSavingRules"
            [areRuleActionsExternallyDisabled]="getRuleActionsDisabled()"
            [isProcessRulesButtonDisabled]="getProcessRulesButtonDisabled()"
            [pendingGeneratedRuleDraft]="pendingGeneratedRuleDraft"
            (processRulesRequested)="processRules()"
            (saveRulesRequested)="saveRules($event)"
            (hasUnsavedRuleChangesChange)="handleUnsavedRuleChangesChange($event)"
            (generatedRuleDraftHandled)="onGeneratedRuleDraftHandled()">
          </auto-ipop-explicit-save-offer-set-rules>
        </p-tabpanel>
      </p-tabpanels>
      </p-tabs>
    </p-panel>
  </div>
</p-panel>
<auto-footer></auto-footer>
